
import { useEffect, useState, startTransition } from 'react';
import { agentService } from '@/services/agentService';
import { AgentListItem } from '@/types/agent';

export const useChatServices = () => {
  const [agents, setAgents] = useState<AgentListItem[]>([]);
  const [isLoadingAgents, setIsLoadingAgents] = useState(true);
  
  // Load agents only once
  useEffect(() => {
    const loadAgents = async () => {
      try {
        console.log('Loading agents for chat services...');
        const fetchedAgents = await agentService.getAllAgents();
        
        startTransition(() => {
          setAgents(fetchedAgents);
          setIsLoadingAgents(false);
        });
      } catch (error) {
        console.warn('Failed to load agents for chat:', error);
        startTransition(() => {
          setIsLoadingAgents(false);
        });
      }
    };
    
    loadAgents();
  }, []);
  
  return {
    agents,
    isLoadingAgents,
  };
};

// Export function to clear cache if needed
export const clearAgentsCache = () => {
  console.log('Chat services cache cleared');
};
